import axios from "axios";
import { ApiEnum } from "../../constants/ApiEnum";

interface ApiGetAddressByPostCodeData {
    data: {
        status: {
            message: {
                street: string;
                city: string;
            };
        };
    };
}

export const ApiGetAddressByPostCode = async (
    postcode: string,
    houseNumber: number,
    houseNumberAddition?: string,
): Promise<ApiGetAddressByPostCodeData> => {
    const response = await axios.get(ApiEnum.POSTCODE + "/get", {
        params: {
            zip_code: postcode,
            house_number: houseNumber,
            house_number_addition: houseNumberAddition,
        },
    });
    return response;
};

interface ApiGetAddressAutoCompleteData {
    data: {
        status: {
            message: object;
        };
    };
}

export const ApiGetAddressAutoComplete = async (
    input: string,
): Promise<ApiGetAddressAutoCompleteData> => {
    const response = await axios.get(
        ApiEnum.POSTCODE_AUTO_COMPLETE + "/?address=" + input,
    );
    return response;
};
